export const getElements = (arr, indexes) =>
  arr.filter(arrEl => arrEl.id === indexes.find(i => i === arrEl.id));
